import { useCallback } from 'react';
import { fetchCharacters } from '@components'
import { CharacterSimple } from '@shared-types'

export type CharacterFetchTypes = 'hot' | 'latest' | 'random' | 'tags';

export const useHandleCharacterFetchClick = () => {
  const handleFetch = useCallback(
    async (
      type: CharacterFetchTypes,
      maxCharacter: number,
      page: number,
      creatorUUID?: string | null,
      tag?: string,
      gender?: string,
      search?: string,
      includeSensitive?: boolean
    ): Promise<{
      characters: CharacterSimple[];
      totalPages: number;
      totalItems: number;
    }> => {
      const result = await fetchCharacters({
        currentPage: page,
        itemsPerPage: maxCharacter,
        sortBy:
          type === 'hot'
            ? 'chat_messages_count'
            : type === 'latest'
              ? 'created_at'
              : undefined,
        genderFilter: gender || null,
        tagsFilter: tag ? [tag] : null,
        filterCreatorUUID: creatorUUID ?? null,
        search: search ?? null,
        include_sensitive: includeSensitive ?? false,
      });

      return {
        characters: result.characters || [],
        totalPages: result.totalPages || 1,
        totalItems: result.totalItems || result.characters?.length || 0,
      };
    },
    []
  );

  return handleFetch;
};